import { useScrollPosition } from '@n8tb1t/use-scroll-position';
import { useState } from 'react';
import isSSR from '../../../utils/isSSR';
var BOTTOM_BUFFER = 2;
var useTimelineViewArea = function (_a) {
    var headerRef = _a.headerRef, bottomRef = _a.bottomRef, _b = _a.isMobile, isMobile = _b === void 0 ? false : _b;
    var _c = useState(false), inView = _c[0], setInview = _c[1];
    var HEADER_TOP_WHEN_STUCK = isMobile ? 87 : 64;
    // check if element is in view
    useScrollPosition(function () {
        var _a, _b;
        if (isSSR())
            return;
        var top = (((_a = headerRef === null || headerRef === void 0 ? void 0 : headerRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) || {}).top;
        var bottom = (((_b = bottomRef === null || bottomRef === void 0 ? void 0 : bottomRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect()) || {}).bottom;
        if (!top || !bottom) {
            setInview(false);
            return;
        }
        if (top === HEADER_TOP_WHEN_STUCK && bottom >= window.innerHeight - BOTTOM_BUFFER) {
            setInview(true);
            return;
        }
        setInview(false);
    }, [HEADER_TOP_WHEN_STUCK], headerRef);
    return { inView: inView };
};
export default useTimelineViewArea;
